'use client'

import { useMemo } from 'react'
import Script from 'next/script'

interface StoryblockProps {
  blockData: string
}

const Storyblock = ({ blockData }: StoryblockProps) => {
  // const styles = `
  //   <style>
  //     :root {
  //         --theme-player-z-index: 1;
  //     }
  //   </style>
  // `
  const data = useMemo(() => {
    if (blockData) {
      return JSON.parse(blockData)
    }
  }, [blockData])

  return (
    <>
      {/* <div dangerouslySetInnerHTML={{ __html: styles }}></div> */}
      <div className="px-4 xl:grid xl:grid-cols-[324px_1fr] xl:px-0">
        <div className="text-[22px] font-bold xl:text-[48px]">{data?.title}</div>
        <div className="overflow-hidden pt-[16px] xl:pl-[42px] xl:pt-0">
          <div>
            <div dangerouslySetInnerHTML={{ __html: data?.data }}></div>
          </div>
        </div>
      </div>
      <Script src="https://asset.fwcdn3.com/js/storyblock.js" async></Script>
      <Script src="https://asset.fwcdn3.com/js/embed-feed.js" async></Script>
    </>
  )
}

export default Storyblock
